import { analytics } from "services/Firebase";
import { enrichWithBrokerParams } from '../brokerAnalyticsContext';

const GA4_MAX_PARAM_LENGTH = 100
const GA4_MAX_PARAM_NAME_LENGTH = 40

function sanitizeGa4Params(params) {
    const sanitized = {}

    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') {
            return
        }

        const paramKey = String(key).slice(0, GA4_MAX_PARAM_NAME_LENGTH)

        if (typeof value === 'object') {
            sanitized[paramKey] = JSON.stringify(value).slice(0, GA4_MAX_PARAM_LENGTH)
            return
        }

        if (typeof value === 'boolean') {
            sanitized[paramKey] = value ? 'true' : 'false'
            return
        }

        if (typeof value === 'number' && Number.isFinite(value)) {
            sanitized[paramKey] = value
            return
        }

        sanitized[paramKey] = String(value).slice(0, GA4_MAX_PARAM_LENGTH)
    })

    return sanitized
}

export default function trackEventFirebaseService(name, params = {}) {
    const jsonStringify = JSON.stringify({
        ...sanitizeGa4Params(enrichWithBrokerParams(params)),
        eventDate: new Date().toISOString().slice(0, GA4_MAX_PARAM_LENGTH),
    })

    const jsonParse = JSON.parse(jsonStringify)

    analytics.logEvent(name, jsonParse);
}

export { sanitizeGa4Params }
